import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetTenantDefaultCarrierMutationVariables = Types.Exact<{
  input: Types.SetTenantDefaultCarrierInput;
}>;


export type SetTenantDefaultCarrierMutation = { __typename?: 'Mutation', setTenantDefaultCarrier: { __typename?: 'TenantCarrierConfigPayload', tenantCarrierConfig?: { __typename?: 'TenantCarrierConfigStateData', tenantId: string, carrier: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type TenantCarrierConfigStateDataFragment = { __typename?: 'TenantCarrierConfigStateData', tenantId: string, carrier: string };

export const TenantCarrierConfigStateDataFragmentDoc = new TypedDocumentString(`
    fragment TenantCarrierConfigStateData on TenantCarrierConfigStateData {
  tenantId
  carrier
}
    `, {"fragmentName":"TenantCarrierConfigStateData"});
export const SetTenantDefaultCarrierDocument = new TypedDocumentString(`
    mutation SetTenantDefaultCarrier($input: SetTenantDefaultCarrierInput!) {
  setTenantDefaultCarrier(input: $input) {
    tenantCarrierConfig {
      ...TenantCarrierConfigStateData
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantCarrierConfigStateData on TenantCarrierConfigStateData {
  tenantId
  carrier
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetTenantDefaultCarrier: build.mutation<SetTenantDefaultCarrierMutation, SetTenantDefaultCarrierMutationVariables>({
      query: (variables) => ({ document: SetTenantDefaultCarrierDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetTenantDefaultCarrierMutation } = injectedRtkApi;
